import * as React from 'react';

/**
 * Small inline icons for the Support settings surfaces. Kept here so the "New …" / "Add …"
 * buttons across the settings tabs share one plus glyph, matching the Claude Design prototype.
 */

/** Plus glyph for "New mailbox", "New category", "Add teammate", etc. */
export function PlusIcon() {
	return (
		<svg
			width='15'
			height='15'
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			strokeWidth='2.2'
			strokeLinecap='round'
			aria-hidden
		>
			<path d='M12 5v14M5 12h14' />
		</svg>
	);
}
